import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_GIFTCARD_SCHEMA_LITERAL = {
    title: 'Schéma GiftCard',
    description: 'GiftCard',
    version: 0,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        
        ID : { type : 'number' },
        MD_DATE_CREATION : { type : 'string' },
        CARTE_DATE_CREATION : { type : 'string' },
        CARTE_NUM : { type : 'string' },
        CARTE_DESIGNATION : { type : ['string', 'null'] },
        DATE_DEBUT : { type : 'string' },
        DATE_EXP : { type : 'string' },
        C_TOTAL_TTC_INIT : { type : 'number' },
        C_TOTAL_TTC_CURRENT : { type : 'number' },
        DO_TIERS_SAGE : { type : 'string' },
        CT_INTITULE_SAGE : { type : 'string' },
        CLU_TICKET : { type : ['string', 'null'] },

        MD_SITEGID : { type : ['string', 'null'] },
        MD_SITE : { type : ['string', 'null'] },
        MD_CAISSE : { type : ['string', 'null'] },
        MD_CAISSIERGID : { type : ['string', 'null'] },
        MD_CAISSIER : { type : ['string', 'null'] },
        MD_CAISSE_SESSION : { type : ['string', 'null'] },
        MD_LOCALGID : { type : ['string', 'null'] }
    },
    required: [ 'CARTE_NUM', 'DATE_DEBUT', 'DATE_EXP', 'C_TOTAL_TTC_INIT' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_GIFTCARD_SCHEMA_LITERAL);
export type RxCluGiftCardDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_GIFTCARD_SCHEMA: RxJsonSchema<RxCluGiftCardDocumentType> = CLU_GIFTCARD_SCHEMA_LITERAL;
